// Copyright (c) 2020 Comsearch, Inc., All rights reserved

const getRadioDetailsSubmitErrors = () => (dispatch, getState) => {
  const {
    databaseDetails,
    form,
  } = getState()

  const sourceForm = databaseDetails.get('sourceForm')

  return form[sourceForm].submitErrors || null
}

export default getRadioDetailsSubmitErrors
